import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import "../Style/InvoiceForm.css";
import "../Style/Common.css";
import "../Style/AddCustomerPopup.css";
import { getOrganizationDetails } from "../Services/orgService";
import Swal from "sweetalert2";

import {
  createInvoice,
  //getBase64FromImageUrl,
  getInvoicesNumber,
} from "../Services/InvoicePageService";
import Footer from "../Footer/Footer";
import Select from "react-select";
import { convertINRToWords, generateNewInvoicePDF, generateQuickInvoicePDF, getCurrentFinancialYear, getStateCode, sanitizeValue } from "../Services/CommonService";
import { getItems } from "../Services/inventoryService";
import { ICustomer, IInvoiceData, IInvoiceFormData, InvoiceFormExtended, InvoiceItem } from "../Interfaces/IInvoice";
import TextField from "@mui/material/TextField/TextField";
import { FormControlLabel, Checkbox, Box, Container, DialogContent, DialogActions, Stack, Button, Dialog, Typography, DialogTitle, IconButton, Autocomplete } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AddItemModelPopup from "../Inventory/AddItemModelPopup";
import { buildInvoiceWhatsAppMessage, shareInvoicePdf } from "../Services/shareInvoiceOnWhatsApp";
import { generateReceipt } from "../Services/InvoiceReceiptService";

declare module "jspdf" {
  interface jsPDF {
    lastAutoTable?: {
      finalY: number; // Position of the last row in the previous table
    };
  }
}

const QuickInvoice: React.FC = () => {
  const [items, setItems] = useState<
    {
      value: string;
      label: string;
      price: number;
      discount: number;
      tax: number;
      hsn: string;
      quantity: number;
    }[]
  >([]); // Dropdown options
  // const [selectedItem, setSelectedItem] = useState<ItemOption | null>(null);

  const [includeShipping, setIncludeShipping] = useState(false);
  const [shippingCharge, setShippingCharge] = useState<number>(0);
  const [invoiceItems, setInvoiceItems] = useState<InvoiceItem[]>([
    {
      itemId: "",
      description: "",
      quantity: 1,
      rate: 1,
      discount: 0,
      tax: 0,
      amount: 0,
      hsn: "",
    },
  ]);
  const [selectedCustomer, setSelectedCustomer] = useState<{
    city: any;
    state: any;
    country: any;
    zipCode: any;
    phone: any;
    GSTIN: any;
    street: any;
    email: any;
    id: string;
    name: string;
  } | null>(null);
  const [orgDetails, setOrgDetails] = useState<any>(null); //Need to update org interface
  const [paidAmount, setPaidAmount] = useState<number | string>("");
  const orgId = localStorage.getItem("orgId") ?? "";

  const discPercentOptions = Array.from({ length: 101 }, (_, i) => i);
  const fetchInvoiceNumber = async () => {
    try {
      const latestInvoiceNumber = await getInvoicesNumber(orgId);
      console.log("Invoice number:" + latestInvoiceNumber);
      setFormData((prev) => ({
        ...prev,
        invoiceNumber: latestInvoiceNumber,
      }));
      //Get Org details
      const orgData = await getOrganizationDetails(orgId); //ACM@PANACCO81
      setOrgDetails(orgData);
    } catch (error) {
      console.error("Failed to fetch the latest invoice number", error);
    }
  };
  const [itemsKey, setItemsKey] = useState(0);
  const [showNewItemPopup, setShowNewItemPopup] = useState(false);
  // Step 4: Print / Download / WhatsApp preview dialog state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [savedPdfArgs, setSavedPdfArgs] = useState<any>(null);
  const [waPhone, setWaPhone] = useState("");
  const [waStatus, setWaStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState<"" | "print" | "download" | "whatsapp">("");
  const loadItems = async () => {
    try {
      const itemData = await getItems(orgId); // Fetch items from API
      const formattedItems = itemData.map((item: any) => ({
        value: item.itemId,
        label: `${item.name} - ${item.desc || "No description"}`, // Combine name and description
        price: item.sellingPrice,
        discount: 0, //bind letter,
        tax: 0,
        hsn: item.hsn,
        quantity: item.quantity,
      }));
      setItems(formattedItems); // Update dropdown options
      setItemsKey((prev) => prev + 1); // ✅ Change key to force re-render
    } catch (error) {
      console.error("Error loading items:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to load items",
        text: "Please try again.",
      });
    }
  };
  useEffect(() => {
    loadItems(); // Fetch items when component mounts
    fetchInvoiceNumber();
  }, []);
  const [formData, setFormData] = useState<InvoiceFormExtended>({
    customerName: "",
    invoiceNumber: "",
    orderNumber: "",
    invoiceDate: new Date().toISOString(),
    terms: "",
    dueDate: new Date().toISOString(),
    salesPerson: "",
    paymentMode: "",
    buyerOrderDate: "",
    contactNumber: "",
  });
  const financialYear = getCurrentFinancialYear() ?? ""

  const handleAddNewItem = () => {
    setInvoiceItems([
      ...invoiceItems,
      {
        itemId: "",
        description: "",
        quantity: 1,
        rate: 1,
        discount: 0,
        tax: 0,
        amount: 0,
        hsn: "",
      },
    ]);
  };
  const handleAddItem = (newItem: any) => {
    // 1️⃣ Build a dropdown‑option out of your saved item
    const newOption = {
      value: newItem.itemId,
      label: `${newItem?.name || ""}`, // or whatever you want to show
      price: newItem?.sellingPrice,
      discount: 0,
      tax: 0,
      hsn: newItem?.hsn,
      quantity: newItem.quantity,
    };

    // 2️⃣ Update your dropdown‑options state
    setItems((prev) => [...prev, newOption]);

    // 3️⃣ And still push it into the invoice rows
    const newItemObject: InvoiceItem = {
      itemId: newItem.itemId,
      description: newItem.name,
      quantity: newItem.quantity,
      rate: newItem.sellingPrice,
      discount: 0,
      tax: 0,
      amount: 0,
      hsn: newItem.hsn,
    };
    setInvoiceItems((prev) => [...prev, newItemObject]);
    // 4️⃣ Close the popup
    setShowNewItemPopup(false);
  };
  const handleRemoveItem = (index: number) => {
    const updatedItems = [...invoiceItems];
    updatedItems.splice(index, 1);
    setInvoiceItems(updatedItems);
  };
  const handleItemChange = (index: number, name: string, value: any) => {
    const updatedItems = [...invoiceItems];
    const selectedItem = items.find((item) => item.value === updatedItems[index].itemId); // Find the selected item
    const enteredVal = Number(value);

    if (name === "quantity") {
      // Allow empty input so the user can type a new number
      if (value === "") {
        updatedItems[index] = { ...updatedItems[index], [name]: value };
        setInvoiceItems(updatedItems);
        return;
      }
      //const enteredQuantity = Number(value);
      // 🔸 Check if the input is a valid number and greater than zero
      if (isNaN(enteredVal) || enteredVal <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Quantity",
          text: "Please enter a valid quantity greater than zero.",
        });
        return; // Stop further execution
      }
      if (selectedItem && enteredVal > selectedItem?.quantity) { // Assuming `stock` is the available stock property
        Swal.fire({
          icon: "error",
          title: "Invalid Quantity",
          text: `Quantity must be less than or equal to ${selectedItem.quantity} for item ${selectedItem.label}.`,
        });
        return; // Stop further execution
      }
    }

    if (name === "rate") {
      // Allow empty input so the user can type a new number
      if (value === "") {
        updatedItems[index] = { ...updatedItems[index], [name]: value };
        setInvoiceItems(updatedItems);
        return;
      }
      // 🔸 Check if the input is a valid number and greater than zero
      if (isNaN(enteredVal) || enteredVal <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Rate",
          text: "Please enter a valid Rate greater than zero.",
        });
        return; // Stop further execution
      }
    }
    updatedItems[index] = { ...updatedItems[index], [name]: value };
    setInvoiceItems(updatedItems);
  };
  const handleGeneratePDF = async () => {
    // Step 1: Validate Invoice Data

    if (!formData.customerName) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Customer Name is required.",
      });
      return;
    }
    if (!formData.contactNumber) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Customer Contact Number is required.",
      });
      return;
    }
    // Validate item rate and quantity
    for (const item of invoiceItems) {
      if (item.rate <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Rate",
          text: "Rate cannot be negative.",
        });
        return;
      }

      if (item.quantity <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Quantity",
          text: "Quantity must be greater than zero.",
        });
        return;
      }
    }
    if (invoiceItems.length === 0 || invoiceItems[0].description === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please add at least one item to the invoice.",
      });
      return;
    }

    const invoiceData: IInvoiceData = {
      orgId: orgId,
      invoiceId: formData.invoiceNumber,
      customerId: selectedCustomer?.id ?? "",
      orderId: formData.orderNumber || "N/A",
      orderDate: "",
      invoiceDate: new Date(formData.invoiceDate).toISOString(),
      customerName: formData?.customerName ?? "N/A",
      totalTax: totalGST,
      buyerStateCode: buyerStateCode,
      sellerStateCode: sellerStateCode,
      isIntraState: isIntraState,
      totalCGST: totalCGST,
      totalSGST: totalSGST,
      buyerGST: orgDetails?.GST || "",//Assume the same state code because from Qucik screen no option to aked customer GST and State code.
      sellerGST: orgDetails?.GST || "",
      totalDiscount: invoiceItems.reduce((acc, item) => acc + item.discount, 0),
      subTotalAmount: subTotal,
      shippingCharge: includeShipping ? shippingCharge : 0,
      roundOff: 0,
      grandTotal: total,
      status: isPaid ? "" : "due",
      invoiceType: "QuickInvoice",
      createdBy: "AdminUser", // Replace with the current user
      createdIp: "", // Replace with actual IP address
      salesPersonId: "", // Add this property
      dueDate: new Date().toISOString(), // Add this property
      salesPersonName: "", // Add this property
      terms: "", // Add this property
      paymentMode: "CASH",
      totalPaidAmount: isPaid ? total : paidAmount,
      phone: formData?.contactNumber || "",
      itemDetails: invoiceItems.map((item, index) => ({
        itemId: item.itemId,
        itemDesc: item.description,
        qty: item.quantity,
        price: item.rate,
        discount: item.discount,
        Tax: item.tax,
        hsn: item.hsn,
        amount: parseFloat(
          (
            item.quantity *
            item.rate *
            (1 - item.discount / 100) *
            (1 + item.tax / 100)
          ).toFixed(2)
        ),
        taxType: "GST", // Replace with dynamic value if applicable
      })),
    };

    const customer: ICustomer = {
      id: selectedCustomer?.id ?? "",
      name: formData?.customerName ?? "N/A",
      email: "",
      phone: formData?.contactNumber || "",
      GSTIN: "",
      street: "",
      city: "",
      state: orgDetails?.address[0]?.state,
      zipCode: "",
      country: "",
      companyName: "",
    };
    try {
      const saveResponse = await createInvoice(invoiceData);
      const customerId = saveResponse?.customerId || "";
      let receiptGenerated = false;
      if (Number(invoiceData.totalPaidAmount) > 0) {
        try {
          await generateReceipt({
            referenceId: formData.invoiceNumber,
            referenceType: "Quick Invoice",
            orgId: orgId,
            customerName: formData?.customerName ?? "N/A",
            customerId: customerId,
            paidAmount: invoiceData.totalPaidAmount || 0,
            paymentMode: formData.paymentMode || "CASH",
            createdBy: "AdminUser",
          });
          receiptGenerated = true;
        } catch (err) {
          console.error("Receipt generation failed:", err);
          Swal.fire({
            icon: "warning",
            title: "Partial Success",
            text: "Invoice saved, but receipt generation failed.",
          });
        }
      }
      // Swal.fire({
      //   title: "Success!",
      //   text: saveResponse.message,
      //   icon: "success",
      //   confirmButtonText: "Ok",
      // });

      // Step 3: Generate PDF if Save is Successful

      // Logic for PDF generation here
      // generateQuickInvoicePDF(
      //           orgDetails,
      //           formData,
      //           formData?.customerName,
      //           invoiceItems,
      //           subTotal,
      //           totalCGST,
      //           totalSGST,
      //           totalGST,
      //           discTotal,
      //           includeShipping,
      //           shippingCharge,
      //           total,
      //           isIntraState,
      //           buyerStateCode,
      //           sellerStateCode,
      //           taxSummary,
      //           financialYear,
      //         );


      setSavedPdfArgs({
        orgDetails,
        formData: { ...formData },
        customer: customer,
        items: [...invoiceItems],
        subTotal,
        totalCGST,
        totalSGST,
        totalGST,
        discTotal,
        includeShipping,
        shippingCharge,
        total,
        isIntraState,
        buyerStateCode,
        sellerStateCode,
        taxSummary: { ...taxSummary },
      });
      setWaPhone(formData?.contactNumber ?? "");
      setWaStatus(null);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: receiptGenerated
          ? "Invoice saved & receipt generated successfully"
          : "Invoice saved successfully",
      }).then(() => {
        setPreviewOpen(true);
      });
      await fetchInvoiceNumber();
      // Refresh the invoice number and items
      setFormData((prev) => ({
        ...prev,
        customerName: "",
        invoiceNumber: "",
        orderNumber: "",
        invoiceDate: new Date().toISOString().split("T")[0],
        terms: "",
        dueDate: new Date().toISOString().split("T")[0],
        salesPerson: "",
        contactNumber: "",
      }));
      await fetchInvoiceNumber();
      // Clear the selected items and reset form
      setInvoiceItems([
        {
          itemId: "",
          description: "",
          quantity: 1,
          rate: 1,
          discount: 0,
          tax: 0,
          amount: 1,
          hsn: "",
        },
      ]);
      await loadItems();
      setShippingCharge(0);
      setSelectedCustomer(null);
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Failed to save invoice: ${error.message}`,
      });
    }
    // End Logic for PDF generation here
  };
  // Step 4: Print / Download / WhatsApp — all three reuse generateBaseInvoicePDF
  const callPdf = (mode: "download" | "print" | "blob") => {
    if (!savedPdfArgs) return null;
    const a = savedPdfArgs;
    return generateNewInvoicePDF(
      a.orgDetails,
      a.formData,
      a.customer,
      a.items,
      a.subTotal,
      a.totalCGST,
      a.totalSGST,
      a.totalGST,
      a.discTotal,
      a.includeShipping,
      a.shippingCharge,
      a.total,
      a.isIntraState,
      a.buyerStateCode,
      a.sellerStateCode,
      a.taxSummary,
      mode,
      a.roundOff
    );
  };

  const confirmPrint = async () => {
    setBusy("print");
    try {
      callPdf("print");
    } catch (error: any) {
      Swal.fire({ icon: "error", title: "Print failed", text: error.message });
    } finally {
      setBusy("");
    }
  };

  const confirmDownload = async () => {
    setBusy("download");
    try {
      callPdf("download");
    } catch (error: any) {
      Swal.fire({ icon: "error", title: "Download failed", text: error.message });
    } finally {
      setBusy("");
    }
  };
  const confirmWhatsAppShare = async () => {
    if (!savedPdfArgs) return;
    if (!waPhone.trim()) {
      setWaStatus("Enter the customer's WhatsApp number first.");
      return;
    }
    setBusy("whatsapp");
    setWaStatus(null);
    try {
      const blob = callPdf("blob") as Blob;
      const message = buildInvoiceWhatsAppMessage(
        savedPdfArgs.formData.invoiceNumber,
        savedPdfArgs.customer?.name ?? savedPdfArgs.customer?.companyName ?? "",
        savedPdfArgs.total
      );
      const result = await shareInvoicePdf(
        blob,
        `Invoice_${savedPdfArgs.formData.invoiceNumber}.pdf`,
        waPhone,
        message
      );
      if (result.method === "web-share") {
        setWaStatus("Shared via WhatsApp ✅");
      } else if (result.method === "manual-attach") {
        setWaStatus(
          "PDF downloaded and WhatsApp chat opened — drag the PDF into the chat to send it."
        );
      }
    } catch (error: any) {
      setWaStatus("Could not prepare the PDF for sharing.");
    } finally {
      setBusy("");
    }
  };
  // Calculate Subtotal
  const subTotal = invoiceItems.reduce(
    (acc, item) => acc + item.quantity * item.rate,
    0
  );
  //Calculate total Disc
  const discTotal = invoiceItems.reduce(
    (acc, item) => acc + (item.quantity * item.rate * item.discount) / 100,
    0
  );
  // Calculate Total GST
  const buyerStateCode = orgDetails?.GST?.substring(0, 2) || getStateCode(orgDetails?.address[0]?.state);//Asume the same state for it because no state preferance//selectedCustomerById?.GSTIN.substring(0, 2) || getStateCode(selectedCustomerById?.state);
  const sellerStateCode = orgDetails?.GST?.substring(0, 2) || getStateCode(orgDetails?.address[0]?.state);
  const isIntraState = buyerStateCode === sellerStateCode;
  // Calculate Total GST
  const totalGST = invoiceItems.reduce(
    (acc, item) => acc + (item.quantity * item.rate * item.tax) / 100,
    0
  );
  let totalCGST = 0;
  let totalSGST = 0;
  if (buyerStateCode === sellerStateCode) {
    totalCGST = totalGST / 2;
    totalSGST = totalGST / 2;
  }

  // Calculate Total (Including GST and Shipping Charge)
  const total =
    invoiceItems.reduce((acc, item) => {
      const itemTotal =
        item.quantity *
        item.rate *
        (1 - item.discount / 100) *
        (1 + item.tax / 100);
      return acc + itemTotal;
    }, 0) + (includeShipping ? shippingCharge : 0); // Add Shipping Charge if enabled

  //Tax summary by tax slab
  type TaxSlab = "3" | "5" | "12" | "18" | "28";
  const taxSummary: Record<TaxSlab, number> = {
    "3": 0,
    "5": 0,
    "12": 0,
    "18": 0,
    "28": 0,
  };
  invoiceItems.forEach((item) => {
    const qty = Number(item.quantity);
    const rate = Number(item.rate);
    const discount = Number(item.discount);
    const tax = Number(item.tax);
    const discountedAmount = qty * rate * (1 - discount / 100);
    const gstAmount = (discountedAmount * tax) / 100;
    const taxKey = tax.toString() as TaxSlab;
    if (taxKey in taxSummary) {
      taxSummary[taxKey] += gstAmount;
    }
  });

  //Paid amount check
  // State to track whether the invoice is marked as paid
  const [isPaid, setIsPaid] = useState(true); // Default checkbox state is checked

  /**
   * Handles the change event for the 'Paid' checkbox.
   * Updates the 'isPaid' state and resets the 'paidAmount' to 0 if unchecked.
   *
   * @param e - The change event from the checkbox input
   */
  const handlePaidChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsPaid(e.target.checked);
    if (!e.target.checked) {
      setPaidAmount(""); // Reset paid amount if unchecked
    }
  };

  return (
    <>
      {/* Location text added directly */}
      <div className="page-location">
        <span>Sales &gt; Quick Invoice</span>
      </div>
      <Container maxWidth="lg" sx={{ padding: 1 }}>


        <form className="invoice-form">
          <div className="form-group">
            <TextField
              label="Customer Name"
              variant="outlined"
              name="customerName"
              value={formData.customerName}
              className="input-item-name"
              required
              onChange={(e) => {
                const regex = /^[a-zA-Z\s._]+$/;
                if (!regex.test(e.target.value)) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Please enter valid customer name",
                  });
                  setFormData({ ...formData, customerName: "" });
                } else {
                  setFormData({ ...formData, customerName: e.target.value });
                }
              }} />
          </div>
          {/* <div className="form-group">
          <TextField
            label="Customer Details"
            variant="outlined"
            name="customerDetails"
            value={formData.customerDetails}
            className="input-item-name"
            onChange={(e) => {
              // const regex = /^[a-zA-Z\s._]+$/;
              // if (!regex.test(e.target.value)) {
              //   setFormData({ ...formData, customerName: "" });
              // } else {
              //   setFormData({ ...formData, customerName: e.target.value });
              // }
               setFormData({ ...formData, customerDetails: e.target.value });
            } } />
        </div> */}

          <div className="form-group">
            <TextField
              label="Contact Number"
              variant="outlined"
              name="contactNumber"
              value={formData.contactNumber}
              className="input-item-name"
              onChange={(e) => {
                const sanitized = e.target.value.replace(/\s+/g, "");
                const regex = /^[+0-9]*$/;

                if (!regex.test(sanitized)) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Please enter valid contact number",
                  });
                  return;
                }
                if (sanitized.length > 10) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Contact number cannot exceed 10 digits",
                  });
                  return;
                }
                setFormData({ ...formData, contactNumber: sanitized });
              }} required />
          </div>
        </form>
        {/* Item Details Container */}
        <div className="invoice-items-container">
          <h3 className="section-title">Item Details</h3>
          <button
            type="button"
            className="add-item-inline-btn"
            onClick={() => setShowNewItemPopup(true)}
            style={{
              fontSize: "0.9em",
              padding: "2px 6px",
              cursor: "pointer",
            }}
          >
            + Add Item
          </button>
          {invoiceItems.map((item, index) => (
            <div key={index} className="item-row">
              <div className="item-fields">
                <label>
                  Item Name:
                  <Select
                    className="input-hsn"
                    key={itemsKey} // ✅ Forces re-render
                    options={items} // Assuming `items` is an array of options
                    value={items.find(
                      (option: { value: any; }) => option.value === invoiceItems[index].itemId
                    )} // Match the value with the `itemId`
                    onChange={(selectedOption) => {
                      // Get the selected item's details from `items`
                      const selectedItem = items.find(
                        (item: { value: string; }) => item.value === selectedOption?.value
                      );

                      if (selectedItem) {
                        // Update the specific item in the `invoiceItems` array
                        const updatedItems = [...invoiceItems];
                        updatedItems[index] = {
                          ...updatedItems[index],
                          description: selectedItem.label, // Use the label for the description
                          itemId: selectedItem.value, // Update the itemId
                          rate: selectedItem.price || 0, // Bind the price to `rate`
                          discount: selectedItem.discount || 0, // Bind the discount
                          tax: selectedItem.tax || 0, //bind the tax
                          hsn: selectedItem.hsn
                        };
                        setInvoiceItems(updatedItems); // Update the state
                      }
                    }}
                    placeholder="Select Item"
                    isSearchable
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "350px",
                      }),
                    }} />
                </label>
                <label>
                  HSN:
                  <input
                    type="text"
                    placeholder="HSN"
                    className="item-input"
                    value={item.hsn}
                    onChange={(e) => {
                      handleItemChange(index, "hsn", e.target.value);
                    }} />
                </label>
                <label>
                  Quantity:
                  <input
                    type="number"
                    placeholder="Quantity"
                    className="item-input"
                    value={item.quantity}
                    onChange={(e) => {
                      handleItemChange(index, "quantity", e.target.value);
                    }} />
                </label>
                <label>
                  Rate:
                  <input
                    type="number"
                    placeholder="Rate"
                    className="item-input"
                    value={item.rate}
                    onChange={(e) => {
                      handleItemChange(index, "rate", e.target.value);
                    }} />
                </label>
                {/* <label>
                Discount:
                <select
                  className="item-input"
                  value={item.discount}
                  onChange={(e) => handleItemChange(index, "discount", e.target.value)}
                >
                  <option value="0">No Discount</option>
                  <option value="5">5%</option>
                  <option value="10">10%</option>
                  <option value="15">15%</option>
                  <option value="20">20%</option>
                </select>
              </label> */}
                <label>
                  Discount (%):
                  <Autocomplete
                    freeSolo
                    disableClearable
                    size="small"
                    sx={{ width: 350 }}
                    options={discPercentOptions.map(String)}
                    inputValue={String(item.discount ?? "")}
                    onInputChange={(_event, newValue, reason) => {
                      if (reason !== "input") return;
                      handleItemChange(index, "discount", newValue);
                    }}
                    onChange={(_event, newValue) => {
                      // Fires when an option is actually clicked/selected
                      // from the dropdown list (onInputChange alone doesn't
                      // catch this — that's why clicking did nothing before).
                      if (newValue === null) return;
                      const numeric = Number(newValue);
                      handleItemChange(index, "discount", isNaN(numeric) ? 0 : numeric);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="0-100"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#fff",
                          },
                        }}
                        onBlur={() => {
                          const numeric = Number(item.discount);
                          if (isNaN(numeric)) {
                            handleItemChange(index, "discount", 0);
                            return;
                          }
                          if (numeric < 0 || numeric > 100) {
                            Swal.fire({
                              icon: "warning",
                              title: "Invalid Discount",
                              text: "Discount must be a percentage between 0 and 100.",
                            });
                          }
                          handleItemChange(index, "discount", Math.min(Math.max(numeric, 0), 100));
                        }}
                      />
                    )}
                  />
                </label>
                <label>
                  Tax:
                  <select
                    className="item-input"
                    value={item.tax}
                    onChange={(e) => handleItemChange(index, "tax", e.target.value)}
                  >
                    <option value="0">Tax Not Applicable</option>
                    <option value="3">3%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                  </select>
                </label>
                <label>
                  Tax Amount:
                  <input
                    type="text"
                    className="item-input"
                    value={item.quantity && item.rate
                      ? (
                        item.quantity *
                        item.rate *
                        (1 - item.discount / 100) *
                        (item.tax / 100)
                      ).toFixed(2)
                      : "0.00"}
                    readOnly />
                </label>
                <label>
                  Total:
                  <input
                    type="text"
                    className="item-input"
                    value={(
                      item.quantity *
                      item.rate *
                      (1 - item.discount / 100) * // Apply discount
                      (1 + item.tax / 100)
                    ) // Apply tax
                      .toFixed(2)}
                    readOnly />
                </label>
              </div>
              <img
                src="/icons8-delete-94.png"
                alt="Remove"
                className="remove-button"
                onClick={() => handleRemoveItem(index)} />
            </div>
          ))}
          <button
            type="button"
            className="add-item-button"
            onClick={handleAddNewItem}
          >
            + Add New Item
          </button>
          <div className="totalprice">
            <div className="form-subtotal">
              <label>Sub Total:</label>
              <span className="form-output">{subTotal.toFixed(2)}</span>
            </div>
            {/* <div className="form-IGST">
      <label>IGST:</label>
      <span className="form-output">{totalGST.toFixed(2)}</span>
    </div> */}
            {isIntraState ? (
              <><div className="form-IGST">
                <label>CGST</label>
                <span className="form-output">{totalCGST?.toFixed(2)}</span>
              </div><div className="form-SGST">
                  <label>SGST</label>
                  <span className="form-output">{totalSGST.toFixed(2)}</span>
                </div></>
            ) : (
              <div className="form-IGST">
                <label>IGST</label>
                <span className="form-output">{totalGST.toFixed(2)}</span>
              </div>
            )}
            <div className="shipping-charge">
              <label className="shipping-label">
                <input
                  type="checkbox"
                  checked={includeShipping}
                  onChange={(e) => setIncludeShipping(e.target.checked)} />
                Include Shipping Charge
              </label>
              {includeShipping && (
                <input
                  type="text"
                  className="shipping-input"
                  placeholder="Enter Shipping Charge"
                  value={shippingCharge}
                  // onChange={(e) => setShippingCharge(Number(e.target.value))}
                  onChange={(e) => {
                    // const value = Number(e.target.value);
                    // if (value >= 0) {
                    //   setShippingCharge(value);
                    // } else {
                    //   Swal.fire({
                    //     icon: "warning",
                    //     title: "Invalid Shipping Charge",
                    //     text: "Shipping charge must be greater than or equalto zero.",
                    //   });
                    // }
                    const numericValue = Number(e.target.value.trim());
                    // Prevent negative numbers
                    if (isNaN(numericValue) || numericValue < 0) {
                      Swal.fire({
                        icon: "warning",
                        title: "Invalid Shipping Charge",
                        text: "Shipping charge must be greater than or equal to zero.",
                      });
                      return;
                    }
                    setShippingCharge(numericValue);
                  }} />
              )}
            </div>

            <div className="form-total">
              <label>Total:</label>
              <span className="form-output">{Math.round(total).toFixed(2)}</span>
            </div>
            <div className="form-total">
              <label>Amount in words</label>
              <label className="form-output">
                {convertINRToWords(Number(Math.round(total).toFixed(2)))}
              </label>
            </div>
          </div>

          <div
            className="form-paid"
            style={{ marginTop: "20px", textAlign: "center" }}
          >
            <div className="paid-container">
              <FormControlLabel
                control={<Checkbox
                  defaultChecked
                  checked={isPaid}
                  onChange={handlePaidChange}
                  sx={{
                    color: "#007bff",
                    "&.Mui-checked": {
                      color: "#0056b3",
                    },
                  }} />}
                label="Paid" />
              <TextField
                type="number"
                className="paid-input"
                placeholder="Enter Paid Amount"
                value={paidAmount}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value >= 0) {
                    setPaidAmount(value);
                  } else {
                    Swal.fire({
                      icon: "warning",
                      title: "Invalid Paid Amount",
                      text: "Paid amount must be greater than or equal to zero.",
                    });
                  }
                }}
                style={{ display: isPaid ? "none" : "block" }}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#ddd",
                    },
                    "&:hover fieldset": {
                      borderColor: "#007bff",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#0056b3",
                    },
                  },
                }} />
            </div>
          </div>

          <button
            type="button"
            className="generate-button"
            onClick={handleGeneratePDF}
          >
            Save & Generate Invoice
          </button>
        </div>
        {showNewItemPopup && (
          <AddItemModelPopup
            orgId={orgId}
            onSave={handleAddItem}
            onClose={() => setShowNewItemPopup(false)}
          />
        )}
      </Container>
      {/* Step 4: Preview -> Print / Download / WhatsApp dialog,
                    same model/pattern as ViewInvoiceDetails, backed by generateBaseInvoicePDF */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Invoice Preview
          <IconButton size="small" onClick={() => setPreviewOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {savedPdfArgs && (
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                {savedPdfArgs.formData.invoiceNumber}
              </Typography>
              <Typography variant="body2">
                {savedPdfArgs.customer?.name ??
                  savedPdfArgs.customer?.companyName}
              </Typography>
              <Box mt={1}>
                <Typography variant="body2">
                  Subtotal: Rs.{savedPdfArgs.subTotal.toFixed(2)}
                </Typography>
                {savedPdfArgs.isIntraState ? (
                  <>
                    <Typography variant="body2">
                      CGST: Rs.{savedPdfArgs.totalCGST.toFixed(2)}
                    </Typography>
                    <Typography variant="body2">
                      SGST: Rs.{savedPdfArgs.totalSGST.toFixed(2)}
                    </Typography>
                  </>
                ) : (
                  <Typography variant="body2">
                    IGST: Rs.{savedPdfArgs.totalGST.toFixed(2)}
                  </Typography>
                )}
                <Typography variant="subtitle2" fontWeight={700}>
                  Grand Total: Rs.{savedPdfArgs.total.toFixed(2)}
                </Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{ flexDirection: "column", alignItems: "stretch", gap: 1, p: 2 }}
        >
          <Stack direction="row" spacing={1}>
            <TextField
              size="small"
              fullWidth
              label="Customer WhatsApp number"
              value={waPhone}
              onChange={(e) => setWaPhone(e.target.value)}
            />
            <Button
              variant="outlined"
              color="success"
              startIcon={<WhatsAppIcon />}
              disabled={busy !== ""}
              onClick={confirmWhatsAppShare}
            >
              {busy === "whatsapp" ? "Preparing…" : "Share"}
            </Button>
          </Stack>
          {waStatus && (
            <Typography variant="caption" color="text.secondary">
              {waStatus}
            </Typography>
          )}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={() => setPreviewOpen(false)}>Close</Button>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              disabled={busy !== ""}
              onClick={confirmDownload}
            >
              {busy === "download" ? "Generating…" : "Download PDF"}
            </Button>
            <Button
              variant="contained"
              startIcon={<PrintIcon />}
              disabled={busy !== ""}
              onClick={confirmPrint}
            >
              Print
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
        }}
      >
        <Footer />
      </Box></>
  );
};
export default QuickInvoice;
